module.exports = __webpack_public_path__ + "img/what-are-coronaviruses-carousel-0-image.c93ee488.png";